import IGenericError from 'src/Models/Server/IGenericError'
import { ICreateEventRequest } from 'src/Models/Server/Request/Event/ICreateEventRequest'
import { IEditEventRequest } from 'src/Models/Server/Request/Event/IEditEventRequest'
import { IEventEditVTO } from 'src/Models/Server/Response/Event/IEventEditVTO'
import EventController from 'src/Services/ToprCoreApi/Axios/Controllers/EventController'
import { appUiStore } from 'src/Stores/AppUiStore'
import { IEventFormValues } from '../Components/Reducer'

export interface IState {
  isSubmitting: boolean
  isLoading: boolean
  eventEdit?: IEventEditVTO
}

export const initialState: IState = {
  isSubmitting: false,
  isLoading: true,
  eventEdit: undefined,
}

export type Actions =
  | {
      type: 'setIsSubmitting'
      isSubmitting: boolean
    }
  | {
      type: 'initialized'
      eventEdit: IEventEditVTO
    }
export const reducer = (state: IState, action: Actions): IState => {
  switch (action.type) {
    case 'initialized':
      return {
        ...state,
        eventEdit: action.eventEdit,
        isLoading: false,
      }
    case 'setIsSubmitting':
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      }
    default:
      throw new Error('Invalid Reducer Action')
  }
}

export const reducerActions = (
  state: IState,
  dispatch: (action: Actions) => void
) => {
  return {
    getEventEdit: (eventId: string) => {
      EventController.GetEventEdit(eventId)
        .then((eventEdit) => {
          dispatch({ type: 'initialized', eventEdit })
        })
        .catch((error: IGenericError) => {
          appUiStore.ShowError(error)
          //dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
    },
    save: (eventId: string, data: IEventFormValues) => {
      const request: IEditEventRequest = {
        EventId: eventId,
        Description: data.Description,
        Name: data.Name,
        ImageFile: {
          Data: data.ImageFile.Data,
          MimeType: data.ImageFile.MimeType,
          Name: data.ImageFile.Name,
        },
        ConsumerSubscriptionId: undefined,
        End: data.End,
        Start: data.Start,
      }

      dispatch({ type: 'setIsSubmitting', isSubmitting: true })
      EventController.EventEdit(request)
        .then(() => {
          history.back()
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
        .catch((error: IGenericError) => {
          appUiStore.ShowError(error)
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
    },
  }
}
